import BookingWidget from "./BookingWidget";
import Navbar from "./Navbar";
import heroBg from "@/assets/hero-pc.webp";
import heroBg640 from "@/assets/hero-pc-640.webp";
import heroBg960 from "@/assets/hero-pc-960.webp";
import heroBg1280 from "@/assets/hero-pc-1280.webp";
import { ShieldCheck, Clock, BadgeCheck } from "lucide-react";


const highlights = [
  { icon: ShieldCheck, text: "Licensed & insured drivers" },
  { icon: Clock, text: "Free 60-min airport waiting" },
  { icon: BadgeCheck, text: "Free cancellation up to 24h" },
];

const HeroSection = () => {
  return (
    <section className="relative flex flex-col">
      {/* Static hero image — optimized for LCP */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={heroBg1280}
          srcSet={`${heroBg640} 640w, ${heroBg960} 960w, ${heroBg1280} 1280w, ${heroBg} 1920w`}
          sizes="100vw"
          alt="Private airport transfer van with chauffeur outside Punta Cana International Airport, Dominican Republic"
          className="w-full h-full object-cover"
          width={1920}
          height={1088}
          fetchPriority="high"
          decoding="async"
        />

        <div className="absolute inset-0 bg-gradient-to-b from-hero-bg/85 via-hero-bg/70 to-hero-bg/97" />
      </div>

      <Navbar />

      <div className="relative z-10 px-4 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="container mx-auto">
          <div className="max-w-3xl mx-auto text-center mb-10">
            <p className="text-primary font-sans font-semibold tracking-[0.28em] uppercase text-xs md:text-sm mb-4">
              Premium Airport &amp; Hotel Transfers
            </p>
            <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-hero-foreground leading-[1.1] mb-5">
              Private Transfers in{" "}
              <span className="text-gradient-orange">Punta Cana</span> &amp; the
              Dominican Republic
            </h1>
            <p className="text-hero-foreground/75 font-sans text-base md:text-lg max-w-2xl mx-auto">
              Door-to-door private rides from PUJ, SDQ, STI, POP and LRM to any
              resort, villa or city. Fixed prices, meet &amp; greet, 24/7 service.
            </p>

            <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 mt-6">
              {highlights.map((h) => (
                <li
                  key={h.text}
                  className="flex items-center gap-2 text-hero-foreground/80 font-sans text-sm"
                >
                  <h.icon className="w-4 h-4 text-primary" aria-hidden="true" />
                  {h.text}
                </li>
              ))}
            </ul>
          </div>

          <BookingWidget />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
